<template>
  <v-app id="sad-config-ui">
    <app-header />

    <v-content style="margin-top: 64px">
      <v-container
        fluid
      >
        <v-card class="pa-2">
          <v-card-title>
            {{ currentRouteName }}
          </v-card-title>
          <router-view />
        </v-card>
      </v-container>
    </v-content>

    <app-footer />
  </v-app>
</template>

<script>

  export default {
    name: 'App',

    components: {
      AppHeader: () => import('./components/AppHeader'),
      AppFooter: () => import('./components/AppFooter'),
    },

    computed: {
      currentRouteName () {
        return this.$route.name
      },
    },

  }
</script>
